import ViewViewModel from '@/ViewModels/ViewViewModel';
import RADApplication from '@/Management/RADApplication';
import ComponentManager from '@/Management/ComponentManager';
import * as CoreFrameInterfaces from '#/CoreFrameInterfaces';

/**
 * Repräsentiert das ViewModel des Wireframes
 */
export default class WireframeViewModel extends ViewViewModel {

    public principalName: KnockoutObservable<string>;
    public principalClass: KnockoutComputed<string>;

    public constructor(params: CoreFrameInterfaces.WireframeViewModelConstructorParameter) {
        super(params);

        this.principalName = this.observableOrDefault(params.principalName, RADApplication.getInstance().user.principal);

        this.principalClass = this.defineComputed(() => {
            let principal = this.principalName();
            if (!!principal) {
                return principal.toLowerCase().replace(/ /g, "") + 'Principal';
            }
            return 'noPrincipal';
        });
    }
}

ComponentManager.setViewModel('WireframeViewModel', WireframeViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');